import { SideBarDef } from "ag-grid-enterprise";
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
import { TCiqAgGrid } from "components/ciq-grid-view-wrapper/model";
import { GridLoadingIndicator } from "components/widgets";
import { useEffect, useMemo, useState } from "react";

function CiqAgGrid<TData = any>(props: TCiqAgGrid) {
  const {
    gridRef: ref,
    rowData,
    additionalGridComponent,
    disableResizingAutoWidth = false
  } = props;
  const [isGridReady, setGridReady] = useState(false);

  const gridOptions: AgGridReactProps<TData> = {
    headerHeight: 36,
    defaultColDef: {
      sortable: true,
      editable: false,
      filter: false,
      resizable: true,
      menuTabs: [],
      flex: 1
    },
    overlayNoRowsTemplate: "No Data Found",
    autoGroupColumnDef: {
      headerName: "",
      field: "",
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: {
        checkbox: true
      }
    },
    loadingOverlayComponent: GridLoadingIndicator,
    suppressAggFuncInHeader: true,
    suppressDragLeaveHidesColumns: true,
    suppressContextMenu: true,
    suppressClickEdit: true,
    cacheQuickFilter: true,
    maintainColumnOrder: true,
    readOnlyEdit: true,
    enableCellTextSelection: true,
    animateRows: false,
    tooltipShowMode: "whenTruncated",
    rowSelection: {
      mode: "multiRow",
      selectAll: "filtered"
    },
    selectionColumnDef: {
      sortable: true,
      resizable: false,
      width: 40,
      suppressHeaderMenuButton: true,
      pinned: "left",
      lockPinned: true
    },
    onGridReady: () => {
      setGridReady(true);
    },
    ...props
  } as AgGridReactProps;

  useEffect(() => {
    if (ref.current && isGridReady && rowData?.length === 0) {
      const { api } = ref.current;
      if (api) {
        api.setGridOption("loading", false);
      }
    }
  }, [rowData, isGridReady, ref]);

  useEffect(() => {
    if (disableResizingAutoWidth) return;
    function handleResize() {
      if (isGridReady && ref && ref.current) {
        ref.current!.api.sizeColumnsToFit();
      }
    }
    window.addEventListener("resize", handleResize);
  }, [ref, isGridReady, disableResizingAutoWidth]);

  const sideBar = useMemo(
    () =>
      ({
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnSelectAll: true
            }
          }
        ],
        position: "right"
      } as SideBarDef),
    []
  );

  return (
    <div className="grow ag-theme-alpine relative">
      <AgGridReact<TData> sideBar={sideBar} {...gridOptions} ref={ref} />
      {additionalGridComponent}
    </div>
  );
}
export default CiqAgGrid;
